module.exports = __webpack_public_path__ + "img/Caitlin.f4ecf2a0.jpg";